module.exports = __webpack_public_path__ + "static/img/21.8d6d7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/21.jpg
// module id = sVyb
// module chunks = 16